import { render, staticRenderFns } from "./InfoHome.vue?vue&type=template&id=51e80c30&scoped=true&"
import script from "./InfoHome.vue?vue&type=script&lang=js&"
export * from "./InfoHome.vue?vue&type=script&lang=js&"
import style0 from "./InfoHome.vue?vue&type=style&index=0&id=51e80c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e80c30",
  null
  
)

export default component.exports